export default [
    {
        path: 'exportacao',
        component: () => import(/* webpackChunkName: 'apac-exportacao' */ '@/views/apac/exportacao/Index'),
        redirect: 'exportacao/index',
        children: [
            {
                name: 'apac-exportacao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'apac-exportacao-index' */'@/views/apac/exportacao/List.vue'),
            },
        ],
    },
]